import React from 'react';

import LogoutButton from '@/components/LogoutButton';
import { selectUser } from '@/features/user/selectors';

import { useSelector } from 'react-redux';

import './styles.scss';

export const Footer = () => {
  const user = useSelector(selectUser);

  return (
    <div className="flex-col h-100 justify-between">
      {user && <LogoutButton />}
      <hr className="my-4" />
      <div className="text-center mb-2 text-xs">
        <p>Copyright {new Date().getFullYear()}. All rights reserved.</p>
      </div>
      <a
        href="https://cloversport.help"
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs"
      >
        Help Center
      </a>
    </div>
  );
};
